import { CommonElementType } from "@utils/DynamicComponentUtils";
import { type CommonContentsRenderType, type CommonCreateBodyKeyType, type CommonDataType } from "src/types/common";
import { type V2AppVersionCreateRequestDto, V2AppVersionCreateRequestDtoPlatform as Platform } from "@everon-it/api-client/contents-gw";

type AppVersionCreateInitValuesType = Omit<V2AppVersionCreateRequestDto, "createdBy">;

export type AppVersionCreateContentsOptionType = {
    placeholder?: string;
    textAreaRows?: number;
} & CommonContentsRenderType;

export const AppVersionCreateData: CommonDataType<CommonCreateBodyKeyType, AppVersionCreateInitValuesType, AppVersionCreateContentsOptionType> = {
    createBodyKey: ["platform", "versionName", "releaseNotes", "isForceUpdate"],
    formInitialValues: {
        platform: Platform.IOS,
        versionName: "",
        releaseNotes: "",
        isForceUpdate: false,
    },
    contentsOption: [
        {
            label: "OS",
            name: "platform",
            type: CommonElementType.RADIO,
            options: [
                { label: "IOS", value: Platform.IOS },
                { label: "ANDROID", value: Platform.ANDROID },
            ],
        },
        {
            label: "강제 업데이트",
            name: "isForceUpdate",
            type: CommonElementType.TOGGLE,
        },
        {
            label: "버전",
            name: "versionName",
            type: CommonElementType.INPUT,
            placeholder: "버전을 입력해주세요",
        },
        {
            label: "릴리즈 노트(선택)",
            name: "releaseNotes",
            type: CommonElementType.TEXTAREA,
            placeholder: "릴리즈 노트를 입력해주세요",
            textAreaRows: 4,
        },
    ],
};
